<template>
	<footer class="footer">
		<div class="footer-container">
			<div class="footer-grid">
				<div class="footer-column">
					<h4>关于我们</h4>
					<ul class="footer-links">
						<li><a href="#" @click.prevent="navigate('about')">中心简介</a></li>
						<li><a href="#" @click.prevent="navigate('history')">发展历程</a></li>
						<li><a href="#" @click.prevent="navigate('honors')">资质荣誉</a></li>
						<li><a href="#" @click.prevent="navigate('partners')">合作伙伴</a></li>
					</ul>
				</div>

				<div class="footer-column">
					<h4>培训服务</h4>
					<ul class="footer-links">
						<li><a href="#" @click.prevent="navigate('courses')">课程体系</a></li>
						<li><a href="#" @click.prevent="navigate('teachers')">师资力量</a></li>
						<li><a href="#" @click.prevent="navigate('training-base')">实训基地</a></li>
						<li><a href="#" @click.prevent="navigate('online-learning')">在线学习</a></li>
					</ul>
				</div>

				<div class="footer-column">
					<h4>认证考试</h4>
					<ul class="footer-links">
						<li><a href="#" @click.prevent="navigate('exam-schedule')">考试安排</a></li>
						<li><a href="#" @click.prevent="navigate('registration')">报名流程</a></li>
						<li><a href="#" @click.prevent="navigate('certificate-query')">证书查询</a></li>
						<li><a href="#" @click.prevent="navigate('faq')">常见问题</a></li>
					</ul>
				</div>

				<div class="footer-column">
					<h4>联系我们</h4>
					<ul class="footer-links">
						<li class="contact-info">
							<span class="contact-icon">📞</span>
							<span>电话：{{ contactInfo.phone }}</span>
						</li>
						<li class="contact-info">
							<span class="contact-icon">📧</span>
							<span>邮箱：{{ contactInfo.email }}</span>
						</li>
						<li class="contact-info">
							<span class="contact-icon">📍</span>
							<span>地址：{{ contactInfo.address }}</span>
						</li>
						<li class="contact-info">
							<span class="contact-icon">🕒</span>
							<span>工作时间：{{ contactInfo.workTime }}</span>
						</li>
					</ul>
				</div>
			</div>

			<div class="footer-bottom">
				<div class="footer-bottom-content">
					<p class="copyright">
						© {{ currentYear }} {{ siteName }} 版权所有 | {{ icp }}
					</p>
					<div class="footer-links-inline" v-if="bottomLinks.length > 0">
						<a v-for="link in bottomLinks" :key="link.path" href="#" @click.prevent="navigate(link.path)"
							class="footer-link-inline">
							{{ link.name }}
						</a>
					</div>
				</div>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		name: 'SiteFooter',
		props: {
			siteName: {
				type: String,
				default: '钢结构行业AI+现场工程师联合培养中心'
			},
			icp: {
				type: String,
				default: '京ICP备2024888888号'
			},
			contactInfo: {
				type: Object,
				default: () => ({
					phone: '400-888-8888',
					email: 'info@steelai.cn',
					address: '北京市朝阳区建国路88号',
					workTime: '周一至周五 9:00-18:00'
				})
			},
			bottomLinks: {
				type: Array,
				default: () => [{
						name: '隐私政策',
						path: 'privacy'
					},
					{
						name: '服务条款',
						path: 'terms'
					},
					{
						name: '免责声明',
						path: 'disclaimer'
					}
				]
			}
		},
		computed: {
			currentYear() {
				return new Date().getFullYear();
			}
		},
		methods: {
			navigate(path) {
				this.$emit('navigate', path);
			}
		}
	}
</script>

<style scoped>
	/* CSS变量定义 */
	:root {
		--primary-blue: #0d47a1;
		--secondary-blue: #1565c0;
		--accent-blue: #1976d2;
		--light-blue: #e3f2fd;
		--text-dark: #263238;
		--text-light: #546e7a;
		--white: #ffffff;
		--gray-light: #f5f5f5;
		--gray-border: #e0e0e0;
		--success: #2e7d32;
		--warning: #f57c00;
		--glass-white: rgba(255, 255, 255, 0.9);
		--glass-blue: rgba(13, 71, 161, 0.05);
	}

	.footer {
		background: var(--text-dark);
		color: white;
		padding: 60px 0 30px;
	}

	.footer-container {
		max-width: 1400px;
		margin: 0 auto;
		padding: 0 40px;
	}

	.footer-grid {
		display: grid;
		grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
		gap: 40px;
		margin-bottom: 40px;
	}

	.footer-column h4 {
		font-size: 18px;
		font-weight: 600;
		margin-bottom: 20px;
		color: white;
	}

	.footer-links {
		list-style: none;
		padding: 0;
		margin: 0;
	}

	.footer-links li {
		margin-bottom: 12px;
	}

	.footer-links a {
		color: rgba(255, 255, 255, 0.8);
		text-decoration: none;
		transition: color 0.3s;
		cursor: pointer;
		display: block;
	}

	.footer-links a:hover {
		color: white;
	}

	.contact-info {
		display: flex;
		align-items: flex-start;
		gap: 8px;
		color: rgba(255, 255, 255, 0.8);
		line-height: 1.5;
	}

	.contact-icon {
		font-size: 14px;
		margin-top: 2px;
		flex-shrink: 0;
	}

	.footer-bottom {
		padding-top: 30px;
		border-top: 1px solid rgba(255, 255, 255, 0.1);
	}

	.footer-bottom-content {
		display: flex;
		justify-content: space-between;
		align-items: center;
		flex-wrap: wrap;
		gap: 20px;
	}

	.copyright {
		color: rgba(255, 255, 255, 0.6);
		margin: 0;
		font-size: 14px;
	}

	.footer-links-inline {
		display: flex;
		gap: 20px;
		flex-wrap: wrap;
	}

	.footer-link-inline {
		color: rgba(255, 255, 255, 0.6);
		text-decoration: none;
		font-size: 14px;
		transition: color 0.3s;
		cursor: pointer;
	}

	.footer-link-inline:hover {
		color: rgba(255, 255, 255, 0.8);
	}

	.footer-link-inline:not(:last-child)::after {
		content: '|';
		margin-left: 20px;
		color: rgba(255, 255, 255, 0.3);
	}

	/* 响应式设计 */
	@media (max-width: 768px) {
		.footer {
			padding: 40px 0 20px;
		}

		.footer-container {
			padding: 0 20px;
		}

		.footer-grid {
			grid-template-columns: 1fr;
			gap: 30px;
			margin-bottom: 30px;
		}

		.footer-bottom-content {
			flex-direction: column;
			text-align: center;
			gap: 15px;
		}

		.footer-links-inline {
			justify-content: center;
		}

		.contact-info {
			font-size: 14px;
		}
	}

	@media (max-width: 480px) {
		.footer-links-inline {
			flex-direction: column;
			gap: 10px;
			align-items: center;
		}

		.footer-link-inline:not(:last-child)::after {
			display: none;
		}
	}
</style>